// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__17TSH","empty":"ModalGraph_empty__1mxio"};